import { render, staticRenderFns } from "./SolicitudCLG.vue?vue&type=template&id=67918322"
import script from "./SolicitudCLG.vue?vue&type=script&lang=js"
export * from "./SolicitudCLG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports